import type { JoePlacement, JoePresentationState } from './JoeOverview.types';

/**
 * Single authoritative switch combining the `order.joe.enabled` tenant gate with the
 * supplied presentation state.
 *
 * Host availability is not modelled here. The connected state resolves to `embedded`
 * regardless of the Customer query, because its host (`CustomerCard`) decides on its own
 * whether it renders at all.
 */
export const resolveJoePlacement = (
  isJoeEnabled: boolean,
  state?: JoePresentationState,
): JoePlacement => {
  if (!isJoeEnabled || !state) {
    return 'none';
  }

  switch (state.status) {
    case 'connected':
      return 'embedded';
    case 'disconnected':
    case 'loading':
    case 'error':
      return 'standalone';
    default:
      return 'none';
  }
};
